import { Component, FormEvent, useState } from "react";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import { useNavigate, useParams } from "react-router-dom";
import { newThreadApi } from "../../services/thread";
import { useAuth } from "../../context/authprovider";
import { CSRFToken } from "../../services/auth";

const NewThread = () => {
  const navigate = useNavigate();
  const { topicId } = useParams();
  const [content, setContent] = useState<string>("");
  const [threadsTitle, setThreadsTitle] = useState("");
  const [editorState, setEditorState] = useState<EditorState>(
    EditorState.createEmpty()
  );
  const { userId } = useAuth();

  const onEditorStateChange = (editorState: any) => {
    const text = editorState.getCurrentContent().getPlainText("");
    const lines = text ? text.split("\n") : 0;

    if (lines.length > 15) {
      console.log("Handle here");
    } else {
      setEditorState(editorState);
      setContent(draftToHtml(convertToRaw(editorState.getCurrentContent())));
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("threadsTitle", threadsTitle);
    formData.append("threadsContent", content);
    formData.append("topicId", topicId!);
    formData.append("userId", userId!);

    try {
      const response = await newThreadApi(formData);
      if (response) {
        navigate(`/forum/${topicId}/${response.threadId}`)
      }
    } catch (e) {}
  };

  return (
    <>
    <CSRFToken />
      <form
        className="w-1/2 flex flex-col justify-center max-h-screen"
        onSubmit={handleSubmit}
      >
        <label
          htmlFor="username"
          className="block text-sm font-medium text-gray-700 undefined"
        >
          Title:
        </label>
        <input
          type="text"
          name="threadsTitle"
          maxLength={50}
          onChange={(e) => setThreadsTitle(e.target.value)}
          className="mb-5 appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
        />
        <Editor
          toolbar={{
            options: [
              "inline",
              "blockType",
              "fontSize",
              "fontFamily",
              "list",
              "textAlign",
              "colorPicker",
              "link",
              "emoji",
              "history",
            ],
            inline: { inDropdown: true },
            list: { inDropdown: true },
            textAlign: { inDropdown: true },
            link: { inDropdown: true },
            fontFamily: {
              options: [
                "Arial",
                "Georgia",
                "Impact",
                "Tahoma",
                "Roboto",
                "Times New Roman",
                "Verdana",
              ],
            },
          }}
          editorState={editorState}
          placeholder="Type here"
          wrapperClassName="w-full block leading-normal"
          toolbarClassName="p-0 border-0 bg-white"
          editorClassName="h-auto min-h-full"
          // toolbarClassName="toolbarClassName"
          // wrapperClassName="wrapperClassName"
          // editorClassName="editorClassName"
          // onEditorStateChange={newState => {
          //     setEditorState(newState);
          //     setContent(draftToHtml(convertToRaw(newState.getCurrentContent())));
          // }}
          onEditorStateChange={onEditorStateChange}
        />
        <button
          type="submit"
          className="w-fit h-min text-white bg-blue-700 hover:bg-blue-800 focus:outline-none focus:ring-4 focus:ring-blue-300 font-medium rounded-full text-sm px-5 py-2.5 text-center mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
        >
          Post
        </button>
      </form>
    </>
  );
};

export default NewThread;
